module.exports = __webpack_public_path__ + "media/sfx_oops.ea5a7e79.mp3";